(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brumate-home-tech-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-tech-carousel-section]');

    sections.forEach((section) => {
      const track = section.querySelector('[data-tech-carousel-track]');
      const previousButton = section.querySelector('[data-tech-carousel-prev]');
      const nextButton = section.querySelector('[data-tech-carousel-next]');

      if (!track || !previousButton || !nextButton) {
        return;
      }

      const getStep = () => {
        const firstCard = track.querySelector('.tech-card');
        if (!firstCard) {
          return 0;
        }

        const trackStyles = window.getComputedStyle(track);
        const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap || '0');
        return firstCard.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maxScrollLeft = Math.max(track.scrollWidth - track.clientWidth, 0);
        previousButton.disabled = track.scrollLeft <= 4;
        nextButton.disabled = track.scrollLeft >= maxScrollLeft - 4;
      };

      const scrollByStep = (direction) => {
        const step = getStep();
        if (step <= 0) {
          return;
        }

        track.scrollBy({
          left: step * direction,
          behavior: 'smooth'
        });
      };

      previousButton.addEventListener('click', () => scrollByStep(-1));
      nextButton.addEventListener('click', () => scrollByStep(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brumate-home-tech-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-tech-carousel-section]');

    sections.forEach((section) => {
      const track = section.querySelector('[data-tech-carousel-track]');
      const previousButton = section.querySelector('[data-tech-carousel-prev]');
      const nextButton = section.querySelector('[data-tech-carousel-next]');

      if (!track || !previousButton || !nextButton) {
        return;
      }

      const getStep = () => {
        const firstCard = track.querySelector('.tech-card');
        if (!firstCard) {
          return 0;
        }

        const trackStyles = window.getComputedStyle(track);
        const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap || '0');
        return firstCard.getBoundingClientRect().width + gap;
      };

      const updateButtons = () => {
        const maxScrollLeft = Math.max(track.scrollWidth - track.clientWidth, 0);
        previousButton.disabled = track.scrollLeft <= 4;
        nextButton.disabled = track.scrollLeft >= maxScrollLeft - 4;
      };

      const scrollByStep = (direction) => {
        const step = getStep();
        if (step <= 0) {
          return;
        }

        track.scrollBy({
          left: step * direction,
          behavior: 'smooth'
        });
      };

      previousButton.addEventListener('click', () => scrollByStep(-1));
      nextButton.addEventListener('click', () => scrollByStep(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
